import React, { useState } from 'react'
import Add from './add'
import Grid from './grid'
import { AccordionWithArrow } from '../../../../components'
import { Wrapper } from './style'

const OverAllActivity = () => {
  const [updatedData, setUpdatedData] = useState(null)

  const updatedDataFunc = (data = []) => {
    setUpdatedData(data)
  }

  return (
    <Wrapper>
      <AccordionWithArrow title='Overall Activity' expanded={true} accordionstyle='fieldset'>
        <Add onChange={updatedDataFunc} />
        <Grid gridData={updatedData} />
      </AccordionWithArrow>
    </Wrapper>
  )
}

export default OverAllActivity
